module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.component.html
// module id = ./src/app/pages/pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.component.html
// module chunks = main